import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./Home";
import About from "./About";
import Products from "./Products";
import Locations from "./Locations";
import Contacts from "./Contacts";
import Nuts from "./Nuts";
import Chocolate from "./Chocolate";
import Fruits from "./Fruits";
import Others from "./Others";

import BackToTop from "./components/BackToTop";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />

        {/* Products main page */}
        <Route path="/products" element={<Products />} />

        {/* Products submenu pages */}
        <Route path="/products/nuts" element={<Nuts />} />
        <Route path="/products/chocolate" element={<Chocolate />} />
        <Route path="/products/fruits" element={<Fruits />} />
        <Route path="/products/others" element={<Others />} />

        <Route path="/locations" element={<Locations />} />
        <Route path="/contacts" element={<Contacts />} />
      </Routes>

      <Footer />
      <BackToTop />
    </BrowserRouter>
  );
}

export default App;